import React from 'react'
import { StyledSubjectBannerDiv, StyledBannerOverlay, StyledNextButton } from './subject-banner.style'
import {
    MdTimer,
    MdAssignment,
    MdNavigateNext
} from "react-icons/md";
import { Button } from '../../button'
import { Link } from 'react-router-dom';

const SubjectBanner = ({ subject, term, numberOfTopics }) => {
    return (
        <StyledSubjectBannerDiv>
            <StyledNextButton>
                <MdNavigateNext />
            </StyledNextButton>
            <StyledBannerOverlay>
                <div className="overlay-content">
                    <h2 className="banner-subject-title">Mathematics</h2>
                    <div className="banner-subject-info">
                        <div className="banner-subject-info-item">
                            <MdTimer /> <span>{term} term</span>
                        </div>
                        <div className="banner-subject-info-item banner-subject-topics">
                            <MdAssignment /><span>{numberOfTopics} topics</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '2rem' }}>
                        <Link to='/student/subjects/view'>
                            <Button variant="secondary">Resume</Button>
                        </Link>
                        <Button variant="invert" style={{ marginLeft: '9px' }}>Start over</Button>
                    </div>
                </div>
            </StyledBannerOverlay>
            <img className='banner-subject-image' src="/assets/images/subject/subject_mathematics.png" alt={subject} />
        </StyledSubjectBannerDiv>
    )
}

export { SubjectBanner }
